<template>
  <FocusLayout
    :title="$t('Refresh Password')"
    :subtitle="$t('We\'ll send you an email with instructions to renew your password.')"
  >
    <ForgotPasswordForm v-bind="$attrs" />
  </FocusLayout>
</template>

<script>
import FocusLayout from "@/landing/layout/FocusLayout";
import ForgotPasswordForm from "@c/Auth/ForgotPasswordForm.vue";

export default {
  components: { FocusLayout, ForgotPasswordForm },
};
</script>
